import React from 'react'
import PropTypes from 'prop-types'
import Media from 'sb-media'
import cx from 'classnames'

import ToggleTruncate from 'components/text/ToggleTruncate/ToggleTruncate'
import Title from 'components/_new/typography/deprecated/Title/Title'

import messages from './messages'
import s from './NoteSection.scss'


const SEONoteSection = ({ name, description, img, hdImg, gender, className }) => {
  const title = gender === 'male' ? messages.title.male : messages.title.female

  return (
    <Media mobile>
      {
        (isMobile) => (
          <div className={cx(s.section, className)}>
            <img className={s.image} src={hdImg || img} alt="" />
            <Title
              className={s.title}
              tag="h1"
              message={title}
              values={{ name }}
              uppercase
            />
            {
              Boolean(description) && (
                <ToggleTruncate className={s.description} length={isMobile ? 250 : 650}>
                  {description}
                </ToggleTruncate>
              )
            }
          </div>
        )
      }
    </Media>
  )
}

SEONoteSection.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
  img: PropTypes.string,
  hdImg: PropTypes.string,
  gender: PropTypes.string,
}

export default SEONoteSection
